let sharedCtx = null;

export const getSharedAudioContext = () => {
  if (!sharedCtx) {
    sharedCtx = new (window.AudioContext || window.webkitAudioContext)();
  }
  return sharedCtx;
};

export const resetSharedAudioContext = async () => {
  if (sharedCtx) {
    try {
      await sharedCtx.close();
    } catch (_) {
      // ignore
    }
  }
  sharedCtx = null;
};

export default getSharedAudioContext;
